export default __webpack_public_path__ + "static/media/img1.a1d9a4bc.jpeg";